export enum UnsavedChangesActionType {
  DisableAIMode = 'disable-ai-mode',
  ChangeOrthomosaic = 'change-orthomosaic',
  SwitchTool = 'switch-tool',
  ExitWorkspace = 'exit-workspace',
}

export enum ToolboxShortcutAction {
  SelectTool = 'select-tool',
  PointTool = 'point-tool',
  LineTool = 'line-tool',
  PolygonTool = 'polygon-tool',
  TextboxTool = 'textbox-tool',
  Delete = 'delete',
  Save = 'save',
  Exit = 'exit',
}
